import { createReducer, on } from '@ngrx/store';
import { IAppAppearance } from '../../models/app-appearance.model';
import { loadAppAppearance, loadAppAppearanceFailure, loadAppAppearanceSuccess } from './app-appearance.actions';
import { WhitelabelingData } from 'src/app/app-data/initialwlb.data';
import { IAppState } from '../../models/app.model';

export type AppAppearanceState = IAppState<IAppAppearance>;

export const initialState: AppAppearanceState = {
  data: null,
  isLoading: false,
  error: null
};

export const appAppearanceReducer = createReducer(
  initialState,
  on(loadAppAppearance, (state): AppAppearanceState => ({
    ...state,
    isLoading: true,
    error: null,
    data: null
  })),
  on(loadAppAppearanceSuccess, (state, { response }): AppAppearanceState => ({
    ...state,
    isLoading: false,
    data: response,
    error: null
  })),
  on(loadAppAppearanceFailure, (state, { error }): AppAppearanceState => ({
    ...state,
    isLoading: false,
    data: null,
    error
  }))
);
